import { datadogLogs } from '@datadog/browser-logs';

// Return path of Shopify's Payments Apps API, used by the onsite card provider.
export const PAYMENTS_APPS_CALLBACK_PATH = '/payments_api/redirect/complete';
// Return path of the older gateway-api integration.
export const PAYMENTS_APPS_OLD_CALLBACK_PATH = '/payments_partners/authentication_callback';

export function isPaymentsAppsCallback(url) {
  return typeof url === 'string' && url.includes(PAYMENTS_APPS_CALLBACK_PATH);
}

export function isLegacyPartnersCallback(url) {
  return typeof url === 'string' && url.includes(PAYMENTS_APPS_OLD_CALLBACK_PATH);
}

// The outermost frame that is still ours. Walking up stops at the first cross-origin parent,
// which is Shopify's checkout.
//
// Reading an ancestor's origin throws when it is cross-origin, so the throw is the signal to
// stop rather than an error. Navigating an ancestor is only permitted at all because every
// frame we climb past is same-origin with us.
function outermostSameOriginFrame() {
  let frame = window;

  try {
    while (frame.parent !== frame && frame.parent.location.origin === window.location.origin) {
      frame = frame.parent;
    }
  } catch (error) {
    return frame;
  }

  return frame;
}

// Shopify answers the Payments Apps callback with `x-frame-options: SAMEORIGIN` and
// `frame-ancestors 'self' shop.app shopify.com`, so it loads only where every ancestor is
// Shopify's own. After a real 3DS challenge this screen runs inside a frame of ours nested in
// Shopify's modal, so navigating here is refused and navigating the top frame throws the modal
// away -- and Shopify's page then has no checkout left to report back to.
//
// Navigating our outermost frame instead leaves Shopify's page with only Shopify ancestors, and
// keeps it inside the modal so Shopify can finish the session and close it.
export function redirectToPaymentsAppsCallback(url, data = {}) {
  const frame = outermostSameOriginFrame();

  datadogLogs.logger.info('Notify organization of complete payment', {
    data: {
      ...data,
      climbed_out_of_nested_frame: frame !== window,
      framed: window.top !== window.self,
      nested_below_top: window.top !== window.parent,
      notification_type: 'redirect to return URL',
      redirect_url: url
    }
  });

  frame.location.href = url;
}
